<template>
  <div
    ref="modal"
    class="modal fade"
    :class="{ show: active, 'd-block': active }"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog modal-xl .modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Detail Forecast Period : {{data.period_forecast}}</h5>
     
          
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            v-on:click="$emit('closeModal')"
            aria-label="btn-close"
          ></button>

        </div>
        <div class="modal-header">
          
          <h5 class="modal-title">{{
                              $t("salesNameTxt")
                            }} : {{data.sales_name}}</h5>
         

        </div>


        <!-- <form class="forms-sample" method="POST" @submit.prevent="submitData"> -->
          <div class="modal-body">
           
            <!-- <span class="badge bg-warning">Date : {{data.sales_forecast_header_id}}</span>
            <div class="mb-3"></div>
            <div class="mb-3">
              <label class="form-label">Truck Status</label>
 
                     
                <v-select
                :options="listStatus"
                placeholder="Input Status"
                v-model="status"
                :required="!status"
                return-object
                ></v-select>
                

                <div v-if="errors.status">
                <div
                  v-for="error in errors.status"
                  :key="error"
                  class="alert alert-primary"
                  role="alert"
                >
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div> -->
            <div class="card">
                      <!-- <div class="card-body">
                        <h5 class="General"></h5>
                        <hr>
                        <div class="row mb-3">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("buNameTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-3">
                            <input
                              type="text"
                              class="form-control"
                              id="bu_name"
                              :placeholder="$t('buNameTxt')"
                              v-model="bu_name"
                              disabled
                            />
                            <div v-if="errors.bu_name">
                              <div
                                v-for="error in errors.bu_name"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-1">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("areaNameTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-4">
                            <input
                              type="text"
                              class="form-control"
                              id="area_name"
                              :placeholder="$t('areaNameTxt')"
                              v-model="area_name"
                              disabled
                            />
                            <div v-if="errors.area_name">
                              <div
                                v-for="error in errors.area_name"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                     
                       
                       
                       

                      
                    </div> -->
                  </div>
                  <br />
                  <div class="row card">
                  <div class="card-header">
                      <h5>Detail</h5>
                    <button
                   
                    class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()"
                    >
                    <i class="link-icon" data-feather="download"></i>
                    {{ $t("downloadData") }} .xlsx
                    </button>

                    </div>
 
                  <div class="card-body">
                    
                      <div  class="table-responsive table-striped" style="max-height:500px">
                        <table  class="table table-hover table-bordered table-xs">
                        

                          <thead style="position: sticky;top: 0;background-color:#ab0635;color: white;  text-align: center;"  >
                            <tr style="color: white;">
                              <th>#</th>
                              <th style="color: white;" width="300px">Business Unit</th>
                              <th style="color: white;" width="300px">Area</th>
                             <th style="color: white;" width="300px">Customer Code</th>
                           
                              <th style="color: white;" width="300px">Customer Name</th>
                     
                              <th style="color: white;" v-for="(column, index) in formsdetails_bulan" :key="index"> {{column}}</th>
                             
                       
                            </tr>
                          </thead>

                          <tbody style="background-color:white">
                            

                            <tr v-for="(item, indexs) in formsdetails" :key="`phoneInput-${indexs}`"  >
                              <th>{{ parseInt(indexs)+1 }}</th>
                              <td >{{ item.bu_name }}</td>
                              <td>{{ item.area_name }}</td>
                              <td >{{ item.customer_code }}</td>
                              <td>{{ item.customer_name }}</td>

                          <td  style="text-align: right;" v-for="(column, indexColumn) in formsdetails_bulan" :key="indexColumn">
                             {{formatNumber(item[column])}}</td>
                          </tr>
                         
                          </tbody>

                          <tfoot style="font-weight:bold;text-align: right;">
                            <tr>
                            <td style="text-align: center" colspan="5">TOTAL</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[0]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[1]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[2]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[3]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[4]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[5]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[6]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[7]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[8]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[9]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[10]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[11]))}}</td>

                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[12]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[13]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[14]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[15]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[16]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[17]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[18]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[19]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[20]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[21]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[22]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[23]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[24]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[25]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[26]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[27]))}}</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>

            
          </div>
          <div class="card">
                      <div class="card-body">
            <div class="row mb-3">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("approvalCommentsTxt")
                            }}</label>
                             </div>
                             <div class="col-lg-3">
            <input
                              type="text"
                              class="form-control"
                              id="approval_comments"
                              :placeholder="$t('approvalCommentsTxt')"
                              v-model="approval_comments"
                              
                            />
                          </div>
        </div>
      </div>
    </div>
          <div class="modal-footer">
            <!-- <button
              type="button"
              class="btn btn-danger"
              v-on:click="$emit('closeModal')"
            >
              {{ $t("close_txt") }}
            </button> -->
            
            <button
        
              class="btn btn-danger"
              @click="rejectData()"
            >
             Reject
             <i class="link-icon" data-feather="slash"></i>
            </button>
         
            <button class="btn btn-success"   @click="submitData()">Approve  <i class="link-icon" data-feather="check-square"></i></button>
          </div>
        <!-- </form> -->
      </div>
    </div>
  </div>
</template>

<script>
 

export default {
  components: {
  },
  name: "modalDetailApproval",
  emits: ["closeModal"],
  props: {
    showModal: Boolean,
    data: {},
  },
  watch: {
    showModal: {
      handler(newVal) { 
        this.active = newVal;
        const body = document.querySelector("body");
        this.showModal
          ? body.classList.add("modal-open")
          : body.classList.remove("modal-open");
          this.loadData(this.data.sales_forecast_approval_id);
          this.sales_forecast_approval_id =this.data.sales_forecast_approval_id;
          this.period_year =this.data.period_year;
          this.period_month =this.data.period_month;
        //this.status = this.data.status;
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
        listStatus:["ACTIVE","SERVICE","NO DRIVER","IDLE","IDLE CAP","HOLIDAY"],
        status:'',
        area_name:'',
        bu_name:'',
        approval_comments :'',
        sales_forecast_approval_id:0,
        isLoading: false,
        active: this.showModal,
        sales_forecast_header_ids: this.data.sales_forecast_header_id,
        forms: {},
        errors: [],
        locale: [],
        formsdetails:[],
      formsdetails_bulan:[],
        rules: {
            select: [(v) => !!v || "Item is required"]
        }
      
    };
  },
  methods: {
    resultError(data) {
      var html = "";
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          html += objectData[y] + "<br>";
        }
      }

      this.loadError(html);
    },

    loadError(pesan) {
      this.$swal({
        backdrop: true,
        title: "Warning",
        html: pesan,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },

    loadSuccess(pesan) {
      this.$swal({
        backdrop: true,
        title: "Success",
        html: pesan,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },

   

    success2(msg){
     
      this.$swal({
        icon: 'info',
        backdrop:true,
        title: "Information",
        html:"<p>* "+msg+"</p>",
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      
    },

    

    loadData(id) {
      
      // this.detailAll=[];
      const baseURI = this.$settings.endPoint + "forecast-approval/detail/" + id;
      return this.$http.get(baseURI).then((response) => {
        this.formsdetails = response.data.datas.data;
        this.formsdetails_bulan = response.data.datas.bulan;
       
       
      
   
      
      
    });
    },

    SumTotal(data,bulan){
      var count = Object.keys( data).length;
       
       var total=0;
     for (var x = 0; x < count; x++) {
      
       var nameOb = Object.keys(data)[x];
     
       var objectData = data[nameOb];
     
       total +=  parseInt(objectData[bulan])
      
     }
      return total;
    },

    // loadDataDetail(id) {
    //   // this.detailAll=[];
    //   const baseURI = this.$settings.endPoint + "sales-forecast/detail-view-forecast/" + id;
    //   return this.$http.get(baseURI).then((response) => {
        
    //     this.formsdetails = response.data.datas.data;
    //     this.formsdetails_bulan = response.data.datas.bulan;

   
      
      
    //   });
    // },

    downloadData() {
      const baseURI = this.$settings.endPoint + "/forecast-approval/download-view-forecast/" + this.sales_forecast_approval_id;

      //var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + this.data.sales_name +"_"+this.data.period_forecast+ ".xlsx";

      //var columnFilters = this.serverParams.columnFilters;


      return this.$http
        .get(
          baseURI ,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
         
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    formatNumber(value){
      return parseInt(value).toLocaleString()
    },

    rejectData() {
      if(this.approval_comments == ""){
            this.errors = {approval_comments:[this.$t("approvalCommentsRequired")]};
            this.resultError(this.errors);
      }else{
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataReject"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
        
            this.isLoading = true;
            var forms = {              
              sales_forecast_approval_id:this.data.sales_forecast_approval_id,
              status:"rejected",
              approval_comments:this.approval_comments,
              period_year:this.period_year,
              period_month:this.period_month
               } 
          const baseURI =
            this.$settings.endPoint + "forecast-approval/update/" + this.data.sales_forecast_approval_id;
            this.$http
            .put(baseURI, forms,{ timeout: 10000 })
            .then((response) => {
                this.isLoading = false;
                this.errors         = [];
                this.$emit("closeModal");                
                this.success2(response.data.datas.messages);
            })
            .catch(error => {
            this.isLoading = false;
            if(error.code == "ECONNABORTED"){
                this.error(this.$t("check_internet_connection_txt"));
            }else{

                if (error.response) {
                if(error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else if (error.response.status === 401) {
                    this.$router.push("/authorized-error");
                }else{
                    this.$router.push('/page-not-found');
                }
                }

            }

            });
        }
      });
      }
    },

    submitData() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataApprove"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
         
            this.isLoading = true;
            var forms = {              
              sales_forecast_approval_id:this.data.sales_forecast_approval_id,
              status:"approved",
              approval_comments:this.approval_comments,
              period_year:this.period_year,
              period_month:this.period_month
               } 
          const baseURI =
            this.$settings.endPoint + "forecast-approval/update/" + this.data.sales_forecast_approval_id;
            this.$http
            .put(baseURI, forms,{ timeout: 100000 })
            .then((response) => {
           
                this.isLoading = false;
                this.errors         = [];
                this.$emit("closeModal");                
                this.success2(response.data.datas.messages);
                
            })
            .catch(error => {
            this.isLoading = false;
          
             
            if(error.code == "ECONNABORTED"){
                this.error(this.$t("check_internet_connection_txt"));
            }else{

                if (error.response) {
                if(error.response.status === 422) {
                  
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                }else if (error.response.status === 500) {
                 
                    this.$router.push('/server-error');
                }else if (error.response.status === 401) {
                
                    this.$router.push("/authorized-error");
                }else{
                 
                    this.$router.push('/page-not-found');
                }
                }

            }

            });
        }
      });
         
    },  
 
  },
  mounted() { 
    this.loadData(this.data.sales_forecast_approval_id)
  },
};
</script>

<style scoped>
.blur-content{
  filter: blur(5px); 
  pointer-events: none;
}
.modal {
  background: rgba(0, 0, 0, 0.4);
}
.modal-content {
  background: #fff;
  border-radius: 0px;
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  padding: 0px;
  width: 100%;
  height: 100%;
}
</style>